import React from "react";
import {
  FeaturedVideoBase,
  CopyWrapper,
  Title,
  Description,
} from "./featured-video.styled";
import { YoutubeVideoSliceFragment } from "../../types/graphql";
import Youtube from "../youtube/youtube";
import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";

export type IFeaturedVideoProps = Slice<
  SharedSliceType,
  YoutubeVideoSliceFragment["primary"]
> & { type: SharedSliceType.featured_customers };

const FeaturedVideo = ({
  slice,
  context,
}: SliceComponentProps<IFeaturedVideoProps, IPageContext>) => {
  const title = slice?.primary?.title;
  const description = slice.primary?.description;
  const featuredVideo = slice?.primary?.url;
  return (
    <FeaturedVideoBase>
      {(title || description) && (
        <CopyWrapper>
          {title && <Title>{title}</Title>}
          {description && <Description>{description}</Description>}
        </CopyWrapper>
      )}
      <Youtube
        embedURL={featuredVideo?.embed_url || ""}
        thumbnailURL={featuredVideo?.thumbnail_url || ""}
        title={featuredVideo?.title || ""}
      />
    </FeaturedVideoBase>
  );
};

export default FeaturedVideo;
